"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdLoggerService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
class TpdLoggerService {
    constructor() {
        this.debug = false;
    }
    printError(id, message, value) {
        value
            ? nodejs_library_1.Helpers.ConsoleHelper.error(`[TpdLogger][${id}] - ${message}`, value)
            : nodejs_library_1.Helpers.ConsoleHelper.error(`[TpdLogger][${id}] - ${message}`);
    }
    printLog(id, message, value) {
        value
            ? nodejs_library_1.Helpers.ConsoleHelper.log(`[TpdLogger][${id}] - ${message}`, value)
            : nodejs_library_1.Helpers.ConsoleHelper.log(`[TpdLogger][${id}] - ${message}`);
    }
}
exports.TpdLoggerService = TpdLoggerService;
